import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

const container = document.getElementById("root")!;
// If the container was prerendered (has children), hydrate so the existing
// SSR markup is adopted instead of wiped — prevents a content→blank flash.
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
